import React from "react";
import { Modal, Spinner } from "react-rainbow-components";
import { ModalProps } from "react-rainbow-components/components/Modal";
import { MdCreate, MdCameraAlt, MdSend } from "react-icons/md";
import { InputAdmin } from "../../common/FormComponent";
import { ContainerAddFile } from "../ChatInput/index.style";
import { Container, MenuItem } from "./index.style";
import useModalMenuChat from "./useModalMenuChat";

const ModalMenuChat = (
  props: ModalProps & { uid: string; doctorId: string }
) => {
  const {
    isLoading,
    InputClick,
    fileInput,
    handleFile,
    setIsCreatingRoom,
    isCrateVideoRoom,
    handleSendMeetingRoom,
    setLinkInput,
    linkInput,
  } = useModalMenuChat(props);
  return (
    <Modal
      hideCloseButton
      title={
        !isLoading && (
          <h2 style={{ textAlign: "center", margin: "1rem" }}>แชทเมนู</h2>
        )
      }
      {...props}
    >
      {!isLoading ? (
        <Container>
          <MenuItem onClick={InputClick}>
            <MdCameraAlt />
            ส่งรูป
            <input
              type="file"
              ref={fileInput}
              accept="image/*"
              onChange={handleFile}
              style={{ display: "none", alignSelf: "center" }}
              multiple
            />
          </MenuItem>

          <MenuItem onClick={() => setIsCreatingRoom(!isCrateVideoRoom)}>
            <MdCreate />
            สร้างห้องวีดีโอแชท
          </MenuItem>
          {isCrateVideoRoom && (
            <form
              onSubmit={handleSendMeetingRoom}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <InputAdmin
                style={{ margin: "1rem", flex: 1, height: "40px" }}
                onChange={(e) => setLinkInput(e.target.value)}
                value={linkInput}
                placeholder="เพิ่ม Link Meeting Room"
              />
              <ContainerAddFile
                style={{ margin: "1rem 0" }}
                onClick={handleSendMeetingRoom}
              >
                <MdSend size={24} />
              </ContainerAddFile>
            </form>
          )}
        </Container>
      ) : (
        <Spinner />
      )}
    </Modal>
  );
};

export default ModalMenuChat;
